import { IconContent } from '@icons';

export const doc: IconContent = {
    sm: '<path fill-rule="evenodd" d="M4 14h-.5V2h5.207l.147.146 3.5 3.5.146.147V7l-.002 6.5v.5H4Zm7.5-7-.002 6H4.5V3H8v4h3.5ZM9 3.707 11.293 6H9V3.707Z" />',
};
